export interface LoginRequest {
  email: string;
  password: string;
}

export enum UserRole {
  Student = 'student',
}

export interface LoginResponse {
  token: string;
  refreshToken?: string | null;
  expiresAt?: string | null;
  refreshTokenExpiresAt?: string | null;
  userName: string;
  role: string;
  publicId: string;
  status?: string | null;
  userStatus?: string | null;
  user?: {
    status?: string | null;
    userStatus?: string | null;
  } | null;
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export interface ForgotPasswordResponse {
  message: string;
}

export interface ResetPasswordRequest {
  email: string;
  code: string;
  newPassword: string;
  confirmPassword: string;
}

export interface ResetPasswordValidationResponse {
  email: string;
  fullName: string;
}

export interface AuthState {
  token: string | null;
  refreshToken: string | null;
  userName: string | null;
  role: string | null;
  publicId: string | null;
  status: string | null;
  loading: boolean;
  error: string | null;
  userType: string | null;
  roles: string[];
  permissions: string[];
  permissionsLoaded: boolean;
}
